(() => {
  const SIZE = 9;
  const initialise = async (root) => {
    if (root.dataset.oxPagingInitialised || root.dataset.oxPreview !== 'true') return;
    root.dataset.oxPagingInitialised = 'true';
    const grid = root.querySelector('.rx-journal-mud__grid');
    const pager = root.querySelector('[data-ox-journal-pager]');
    let drafts = [...grid.querySelectorAll('[data-ox-draft-card]')];
    const draftCount = Number(root.dataset.oxPreviewCount || drafts.length);
    if (!pager) return;
    const nativeCount = Number(root.dataset.oxNativeCount);
    const pages = Math.max(1, Math.ceil((nativeCount + draftCount) / SIZE));
    const address = new URL(location.href);
    const requestedPage = Number(address.searchParams.get('journal_page') || address.searchParams.get('page') || 1);
    const page = Math.min(pages, Math.max(1, Number.isFinite(requestedPage) ? Math.floor(requestedPage) : 1));
    if (address.searchParams.has('journal_page')) {
      address.searchParams.delete('journal_page');
      if (page > 1) address.searchParams.set('page', String(page));
      else address.searchParams.delete('page');
      location.replace(address.href);
      return;
    }
    const nativeCards = new Map();
    const addSource = (source) => {
      if (drafts.length < draftCount) {
        const found = [...source.querySelectorAll('[data-ox-draft-card]')];
        if (found.length === draftCount) drafts = found;
      }
      const sourcePage = Number(source.dataset.oxNativePage);
      const cards = [...source.querySelectorAll('.rx-journal-mud__grid > .rx-journal-mud__card:not([data-ox-draft-card])')];
      cards.forEach((card, i) => nativeCards.set((sourcePage - 1) * SIZE + i, card));
    };
    addSource(root);
    const start = (page - 1) * SIZE;
    const end = Math.min(nativeCount + draftCount, start + SIZE);
    const requiredPages = new Set();
    for (let index = Math.max(draftCount, start); index < end; index++) {
      if (!nativeCards.has(index - draftCount)) requiredPages.add(Math.floor((index - draftCount) / SIZE) + 1);
    }
    root.setAttribute('aria-busy', 'true');
    try {
      await Promise.all([...requiredPages].map(async (sourcePage) => {
        const url = new URL(location.href);
        url.searchParams.delete('journal_page');
        url.searchParams.set('page', String(sourcePage));
        url.searchParams.set('section_id', root.dataset.oxSectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Journal source request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-ox-journal-paging]');
        if (!source || Number(source.dataset.oxNativePage) !== sourcePage) throw new Error('Journal source page mismatch');
        addSource(source);
      }));
      const displayed = [];
      const visibleCount = end - start;
      for (let index = start; index < end; index++) {
        const card = index < draftCount ? drafts[index] : nativeCards.get(index - draftCount);
        if (!card) throw new Error('Journal card missing');
        const copy = card.cloneNode(true);
        copy.classList.toggle('rx-journal-mud__card--featured', displayed.length === 0 && visibleCount % 2 === 1);
        displayed.push(copy);
      }
      grid.replaceChildren(...displayed);
      pager.replaceChildren();
      pager.hidden = pages === 1;
      pager.style.display = pages === 1 ? 'none' : '';
      const language = (document.documentElement.lang || 'fr').split('-')[0];
      const labels = {
        fr: { prev: 'Page précédente', next: 'Page suivante', page: 'Page' },
        en: { prev: 'Previous page', next: 'Next page', page: 'Page' },
        de: { prev: 'Vorherige Seite', next: 'Nächste Seite', page: 'Seite' },
        zh: { prev: '上一页', next: '下一页', page: '第' },
      }[language] || { prev: 'Previous page', next: 'Next page', page: 'Page' };
      const pageLink = (number, text, kind) => {
        const span = document.createElement('span');
        span.className = kind;
        if (kind === 'page' && number === page) {
          span.classList.add('current'); span.setAttribute('aria-current', 'page'); span.textContent = text;
        } else {
          const link = document.createElement('a');
          const url = new URL(location.href);
          url.searchParams.delete('journal_page'); url.searchParams.delete('section_id');
          if (number > 1) url.searchParams.set('page', String(number));
          else url.searchParams.delete('page');
          link.href = url.pathname + url.search + '#journal-articles';
          link.textContent = text;
          link.setAttribute('aria-label', kind === 'page' ? (language === 'zh' ? `第 ${number} 页` : `${labels.page} ${number}`) : labels[kind]);
          span.append(link);
        }
        pager.append(span);
      };
      if (page > 1) pageLink(page - 1, '←', 'prev');
      const selected = new Set([1, pages]);
      for (let n = Math.max(1, page - 2); n <= Math.min(pages, page + 2); n++) selected.add(n);
      let previous = 0;
      [...selected].sort((a, b) => a - b).forEach((n) => {
        if (previous && n - previous > 1) {
          const dots = document.createElement('span'); dots.className = 'deco'; dots.textContent = '…'; pager.append(dots);
        }
        pageLink(n, String(n), 'page'); previous = n;
      });
      if (page < pages) pageLink(page + 1, '→', 'next');
      root.dataset.oxPagingReady = 'true';
      root.dataset.oxVisiblePage = String(page);
      root.dataset.oxVisiblePages = String(pages);
      root.dispatchEvent(new CustomEvent('orienx:journal-page-ready', { bubbles: true }));
    } catch (error) {
      console.warn('OrienX journal pagination:', error.message);
      root.dataset.oxPagingFailed = 'true';
    } finally {
      root.removeAttribute('aria-busy');
    }
  };
  const scan = () => document.querySelectorAll('[data-ox-journal-paging]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();



